"use client";

import React, { useEffect, useMemo } from "react";
import { Products } from "@/common/entities/product/Product";
import { ImageWrapper } from "@/common/components/Images/ImageWrapper";
import styles from "./comparePanel.module.scss";
import { FaCheck, FaTimesCircle,  } from "react-icons/fa";
import LocalStorageService from "@/services/localStorageService/LocalStorageService";

interface ComparePanelProps {
    selectedProducts: Products[];
    toggleProduct: (product: Products, isSelected: boolean) => void;
}

const ComparePanel: React.FC<ComparePanelProps> = ({ selectedProducts, toggleProduct }) => {
    const compareUrls = useMemo(() => {
        return selectedProducts.map(p => p.url).sort().join(",");
    }, [selectedProducts]);

    useEffect(() => {
        if (compareUrls || selectedProducts.length > 0) {
            LocalStorageService.setItem("compareUrls", compareUrls ?? selectedProducts);
        }
    }, [compareUrls]);

    if (selectedProducts.length === 0) return null;

    return (
        <div className={styles.comparePanel}>
            <div className={styles.productsList}>
                {selectedProducts.map((product, index) => (
                    <div key={index} className={styles.productItem}>
                        <ImageWrapper
                            className={styles.productImage}
                            width={200}
                            height={200}
                            url={product.defaultImage?.image.originalFileName}
                            title={""}
                        />
                        <button
                            className={styles.removeBtn}
                            onClick={() => toggleProduct(product, false)}
                        >
                            <FaTimesCircle />
                        </button>
                    </div>
                ))}
            </div>
            {selectedProducts.length > 1 && (
                <a href={`/compara`} className={styles.compareBtn}>
                    <FaCheck/>
                </a>
            )}
        </div>
    );
};

export default ComparePanel;
